import modalAccessoriesTemplate from './modalAccessories.html';
import './modalAccessories.scss';

const modalAccessories = () => ({
    template: modalAccessoriesTemplate,
    restrict: 'E',
    scope: {
        accessoriesSelectedOptions: '=',
        accessoriesOptions: '=',
        accessoriesType: '=',
        accessoriesMultiSelect: '=',
        accessoriesTitle: '=',
        accessoriesFieldName: '=',

        packetsSelectedOptions: '=',
        packetsOptions: '=',
        packetsType: '=',
        packetsMultiSelect: '=',
        packetsTitle: '=',
        packetsFieldName: '=',

        closeBoxCallback: '&?',
        openModalCallback: '&?',
        palettes: '=',
        changeStep: '&?',
    },
    controller: 'ModalAccessoriesCtrl',
    controllerAs: 'modalAccessories',
    bindToController: true
});

export default modalAccessories;